// Visibilidade de feature por ambiente (flag genérica, reutilizável).
// Regra: Dev/Stage sempre mostram; em prod só mostra quando
// REACT_APP_HAS_ACCESS_IN_PROD === "true".
const isProd = () => process.env.REACT_APP_ENVIROMENT === "prd";

const hasAccessInProd = () =>
  String(process.env.REACT_APP_HAS_ACCESS_IN_PROD).toLowerCase() === "true";

export const canAccessInCurrentEnv = () => !isProd() || hasAccessInProd();

export default canAccessInCurrentEnv;
